import './connection-banner.scss';

import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

import { DisconnectOutlined } from '@/media/antd-icons';
import { useAppSelector } from '@/store';

/**
 * Баннер потери связи с сокетом подписок. Показывается, пока graphql-ws
 * переподключается: данные на экране могут отставать от сервера.
 */
const ConnectionBanner: React.FC = () => {
  const { t } = useTranslation();
  const status = useAppSelector((state) => state.connection.status);

  if (status !== 'reconnecting') return null;

  return (
    <div className="connection-banner">
      <Alert
        type="warning"
        showIcon
        icon={<DisconnectOutlined />}
        title={t('layout.connection.reconnecting')}
      />
    </div>
  );
};

export default ConnectionBanner;
